export interface PlatformDefinition {
  labelKey: string
  iconKey: string
}

/** Translation/icon catalog ported from the legacy anomaly platform map. */
export const PLATFORM_LABELS: Readonly<Record<string, PlatformDefinition>> = {
  google_ads: { labelKey: 'anomalies.platform.googleAds', iconKey: 'google_ads' },
  meta_ads: { labelKey: 'anomalies.platform.metaAds', iconKey: 'meta_ads' },
  tiktok_ads: { labelKey: 'anomalies.platform.tiktokAds', iconKey: 'tiktok_ads' },
  snapchat_ads: { labelKey: 'anomalies.platform.snapchat', iconKey: 'snapchat_ads' },
  apple_search_ads: {
    labelKey: 'anomalies.platform.appleSearchAds',
    iconKey: 'apple_search_ads',
  },
  shopify: { labelKey: 'anomalies.platform.shopify', iconKey: 'shopify' },
  google_analytics: { labelKey: 'anomalies.platform.ga4', iconKey: 'google_analytics' },
  objective: { labelKey: 'anomalies.platform.objective', iconKey: 'objective' },
  default_workspace: {
    labelKey: 'anomalies.platform.workspace',
    iconKey: 'default_workspace',
  },
}
